import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagER = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M22.826 22.826S7.337 42.681 7.322 42.678A24.921 24.921 0 0 0 25 50c13.807 0 25-11.193 25-25l-27.174-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M22.826 25S7.337 7.319 7.322 7.322A24.921 24.921 0 0 1 25 0c13.807 0 25 11.193 25 25H22.826Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M7.322 7.322c-9.763 9.763-9.763 25.592 0 35.355C7.322 42.681 50 25 50 25L7.322 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M13.043 14.673c-4.794 0-8.695 3.901-8.695 8.696v3.26c0 4.795 3.9 8.696 8.695 8.696s8.696-3.9 8.696-8.695v-3.261c0-4.795-3.9-8.696-8.696-8.696Zm5.435 11.957a5.444 5.444 0 0 1-3.804 5.184V28.26l2.307-2.307-2.306-2.306-.001-.82v-1.089h-3.26V25l-2.306 2.306 2.305 2.305v2.204A5.444 5.444 0 0 1 7.61 26.63v-3.261a5.44 5.44 0 0 1 5.434-5.435 5.44 5.44 0 0 1 5.435 5.435v3.26Z"
}));
FlagER.displayName = 'FlagER';
export default withFlagWrapper(FlagER);
//# sourceMappingURL=index.js.map